export default __webpack_public_path__ + "static/user-o2-009ff98c10e2c8b88eb88cec590bb607.png";